/**
 * When a 500 occurs on a "detail" / parameterized route, derive the parent splat index path
 * (e.g. `/game-list/edit/1` → `/game-list`, `/package/serial/edit/x` → `/package`).
 */
type StripRule = (path: string) => string | null;

const stripRules: StripRule[] = [
  (p) => {
    const m = p.match(/^(.+)\/(edit|detail)\/([^/]+)$/);
    return m ? m[1] : null;
  },
  (p) => {
    if (p.endsWith('/create') && p !== '/create') {
      return p.slice(0, -'/create'.length);
    }
    return null;
  },
  (p) => {
    if (p.endsWith('/import')) {
      return p.replace(/\/import$/, '');
    }
    return null;
  },
  (p) => {
    const m = p.match(/^(.+)\/add\/([^/]+)$/);
    return m ? m[1] : null;
  },
  (p) => {
    if (p.endsWith('/add-transaction')) {
      return p.replace(/\/add-transaction$/, '');
    }
    return null;
  },
  (p) => {
    const m = p.match(/^(.+)\/fund-list\/[^/]+$/);
    return m ? m[1] : null;
  },
  (p) => {
    if (p.endsWith('/sort-games')) {
      return p.replace(/\/sort-games$/, '');
    }
    return null;
  },
  (p) => {
    if (p.endsWith('/discount-configuration')) {
      return p.replace(/\/discount-configuration$/, '');
    }
    return null;
  },
  (p) => {
    if (p.endsWith('/topup-transactions')) {
      return p.replace(/\/topup-transactions$/, '');
    }
    return null;
  },
  (p) => {
    const m = p.match(/^(.+)\/history\/[^/]+$/);
    return m ? m[1] : null;
  },
  (p) => {
    if (p.startsWith('/game-and-package/')) {
      const m = p.match(/^(.+)\/package\/[^/]+$/);
      return m ? m[1] : null;
    }
    return null;
  },
  (p) => {
    if (/\/package\/serial$/.test(p)) {
      return p.replace(/\/serial$/, '');
    }
    return null;
  },
];

function stripOneDynamicLevel(path: string): string | null {
  for (const rule of stripRules) {
    const out = rule(path);
    if (out != null && out !== path) {
      return out.length ? out : '/';
    }
  }
  return null;
}

export function getRouteIndexPathFor500(pathname: string): string | null {
  if (typeof pathname !== 'string' || pathname === '/404') {
    return null;
  }
  let path = pathname.replace(/\/+$/, '') || '/';
  const original = path;

  for (let i = 0; i < 20; i += 1) {
    const next = stripOneDynamicLevel(path);
    if (next == null) {
      break;
    }
    path = next;
  }

  if (path === original) {
    return null;
  }
  return path;
}
